export default {
      id: "icon-data_sources-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-data_sources",
      toString: function () {
        return this.url;
      }
    }